import {
  Household,
  HouseholdFinancial,
  HouseholdMember,
  CreateHouseholdParams,
  UpdateHouseholdParams,
} from 'models/household';
import { apiV2, AxiosResponse } from './axios';

export const getHousehold = async (id?: string): Promise<Household> => {
  const { data } = await apiV2.get<Household>(`households/${id}`);
  return data;
};

export const getHouseholdByUserId = async (
  userId?: string,
): Promise<Household> => {
  const { data } = await apiV2.get<Household>(`households/by-user/${userId}`);
  return data;
};

export const getHouseholdHeadByUserId = async (
  userId?: string,
): Promise<HouseholdMember> => {
  const { data } = await apiV2.get<HouseholdMember>(
    `households/${userId}/head`,
  );
  return data;
};

export const updateHouseholdHead = async (
  id: string,
  data: Partial<HouseholdMember>,
): Promise<Partial<HouseholdMember>> => {
  const { data: response } = await apiV2.patch<Partial<HouseholdMember>>(
    `households/${id}`,
    data,
  );
  return response;
};

export const updateHousehold = async (
  id: string,
  data: UpdateHouseholdParams,
): Promise<Partial<Household>> => {
  const { data: response } = await apiV2.patch<
    unknown,
    AxiosResponse<Partial<Household>>
  >(`households/${id}`, data);
  return response;
};

export const createHousehold = async (
  userId: string,
  data: CreateHouseholdParams,
): Promise<CreateHouseholdParams> => {
  const { data: response } = await apiV2.post<CreateHouseholdParams>(
    `households/${userId}`,
    data,
  );
  return response;
};

export const getHouseholdFinancial = async (
  householdId?: string,
  taxYear?: number,
): Promise<HouseholdFinancial> => {
  const { data } = await apiV2.get<HouseholdFinancial>(
    `households/financials/${householdId}/${taxYear}`,
  );
  return data;
};

export const createHouseholdFinancial = async (
  householdId: string,
  taxYear: number,
  data: Partial<HouseholdFinancial>,
): Promise<Partial<HouseholdFinancial>> => {
  const { data: response } = await apiV2.post<Partial<HouseholdFinancial>>(
    `households/financials/${householdId}/${taxYear}`,
    data,
  );
  return response;
};

export const updateHouseholdFinancial = async (
  householdId: string,
  taxYear: number,
  data: Partial<HouseholdFinancial>,
): Promise<Partial<HouseholdFinancial>> => {
  const { data: response } = await apiV2.patch<Partial<HouseholdFinancial>>(
    `households/financials/${householdId}/${taxYear}`,
    data,
  );
  return response;
};
